export default __webpack_public_path__ + "static/media/styles.e4d3c60f.less";